/** Coerce `FormData` to a string record (file fields use name only; extend if you upload in-dialog). */
export function formDataToStringRecord(data: FormData): Record<string, string> {
  const out: Record<string, string> = {};
  data.forEach((value, key) => {
    if (value instanceof File) {
      out[key] = value.name;
    } else {
      out[key] = String(value);
    }
  });
  return out;
}
